export default StorageManager = {
    getCurrentUser : () => {
        return JSON.parse(localStorage.vuex).login;
    },
    getJWT : (key) => {
        return localStorage.getItem(key);
    },
    saveJWT : (key, jwt) => {
        localStorage.setItem(key, jwt);
    },
    removeJWT : (key) => {
        localStorage.removeItem(key);
    }
};



// WEBPACK FOOTER //
// ./src/utils/storageManager.js